const Btn = ({text, img}) => {
	return (
		<div className='callBtn'>
			<img className='callBtnImg' src={img} alt='call' />
			<div className='callBtnText'>{text}</div>
		</div>
	)
}

export default Btn